import type {
	BackendSessionResponse,
	BaseItemSchema,
} from "@memorang/types/src/session/new-session";

export const orgKey = "ets-toefl-diagnostic";

export const diagnosticTagIds = {
	readingListening: 1000,
	speakingWriting: 1001,
};

const flattenSessionItems = (
	sessionItems: BackendSessionResponse["sessionItems"],
): BaseItemSchema[] => {
	return sessionItems.flatMap((setOrItem): BaseItemSchema[] => {
		if (setOrItem.type === "SET") {
			return (
				setOrItem.items?.map((item, index) => ({
					...item,
					stimulus: setOrItem.stimulus,
					currentStimulusItemIndex: index + 1,
					numTotalStimulusItems: setOrItem.items?.length,
				})) ?? []
			);
		}
		return [setOrItem];
	});
};

export { flattenSessionItems };
